// =====================================================================
// Platform adı ("Powered by <platform>") — tek kaynak.
//
// Kaynak: state.Apps.branding (InitApp -> backend Brand::config()).
//   platformName : 'TourZone' / 'Holideus' (backend Brand::platformName() ile aynı)
//   brand        : platformName yoksa yedek
//   poweredBy    : false ise "Powered by ..." satırı HİÇ gösterilmez (varsayılan true).
//                  Açıp kapatmak için backend/framework/src/Branding/Brand.php içinde
//                  ilgili markanın BRANDS satırına 'poweredBy' => false eklenir (ör. holideus).
//
// Not: vitrin/widget'ta görünen SATICI acentenin adı değil, PLATFORMUN adıdır.
// =====================================================================
import { useSelector } from 'react-redux';
import { mergeBranding } from './brands';

/** Branding objesinden platform adı (API yoksa DEFAULT_BRANDING). */
export const platformBrandName = (branding) => {
    const b = mergeBranding(branding);
    return String(b.platformName || b.brand || 'TourZone');
};

/** "Powered by" satırı gösterilsin mi? Yalnızca açıkça false ise kapalı. */
export const poweredByEnabled = (branding) => mergeBranding(branding).poweredBy !== false;

/** Metindeki sabit "TourZone" geçişini aktif platform adıyla değiştirir (DB çevirileri için). */
export const withPlatformName = (text, name) => String(text || '').replace(/tour\s?zone/gi, name);

/** Hook: { name, poweredBy } — branding gelince bileşeni yeniden çizer. */
export const usePlatformBrand = () => {
    const branding = useSelector((s) => (s && s.Apps ? s.Apps.branding : null));
    return { name: platformBrandName(branding), poweredBy: poweredByEnabled(branding) };
};

/**
 * Class bileşenler için: <PoweredBy render={(name) => <div>... <b>{name}</b></div>} />
 * poweredBy=false ise hiçbir şey çizmez.
 */
export const PoweredBy = ({ render }) => {
    const { name, poweredBy } = usePlatformBrand();
    return poweredBy ? render(name) : null;
};
